import { PhDialog } from './dialog.service';
export { PhDialog };
